var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(this.atLanguage == 'en_US')?_c('img',{attrs:{"src":require("../../assets/img/list/listDetailsEn.jpg"),"alt":""}}):_c('img',{attrs:{"src":require("../../assets/img/list/listDetailsZh.jpg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }